export enum CoreResumeApiTags {
  CurrentClientResume = 'CurrentClientResume',
}

export const coreResumeApiTagTypes = Object.values(CoreResumeApiTags);
